export default "__VITE_ASSET__d5caea54__"